import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, X, KeyRound } from "lucide-react";

export function ResetPasswordModal({ user, onClose, onDone }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw && pw.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/users/${user.id}/reset-password`, { new_password: pw || null });
      toast.success(`Password changed for ${user.name || user.email}`);
      onDone(data);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-[70] flex items-center justify-center px-4" onClick={onClose}>
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-white w-full max-w-md" data-testid="user-reset-modal">
        <div className="px-6 py-4 border-b border-zinc-200 flex items-center justify-between">
          <h3 className="font-display font-bold text-[#0F172A] flex items-center gap-2"><KeyRound className="h-4 w-4 text-[#D4AF37]" /> Change password</h3>
          <button type="button" onClick={onClose} data-testid="user-reset-close" className="text-zinc-400 hover:text-[#0F172A]"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-6 space-y-3 text-sm">
          <p className="text-zinc-600">Set a new password for <b>{user.name || user.email}</b> <span className="font-mono text-xs text-zinc-400">({user.email})</span>. Their old password stops working right away.</p>
          <label className="block text-sm font-medium text-[#0F172A]">New password
            <input type="text" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Leave blank to auto-generate" data-testid="user-reset-password-input"
              className="mt-1.5 w-full px-3 py-2.5 border border-zinc-300 text-sm font-mono outline-none focus:ring-2 focus:ring-[#D4AF37]" />
          </label>
          <p className="text-xs text-zinc-400">At least 8 characters. The new login is also emailed to them when portal emails are on.</p>
        </div>
        <div className="px-6 py-4 border-t border-zinc-200 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm border border-zinc-300">Cancel</button>
          <button type="submit" disabled={busy} data-testid="user-reset-submit" className="flex items-center gap-2 bg-[#0F172A] text-white px-5 py-2 text-sm font-medium hover:bg-[#1E293B] disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Change password
          </button>
        </div>
      </form>
    </div>
  );
}
